import { find, isNil } from 'lodash';

/**
 * Removes a leaflet marker from a leaflet layer group.
 *
 * @param {object} arg - The arguments object.
 * @param {object} arg.layerMarkers - The leaflet layer group to remove the marker.
 * @param {string | number} arg.layerId - The id of the marker layer in the group.
 */
const removeMarkerFromLayer = ({ layerMarkers, layerId }) => {
  const layers = layerMarkers.getLayers();
  const layer = find(layers, layerToCheck => layerToCheck.layerId === layerId);

  if (!isNil(layer)) {
    layerMarkers.removeLayer(layer);
  }
};

export default removeMarkerFromLayer;
